module.exports = {"status":{"disclaimer":{"advise":"Recorrido.pe se contactará con la empresa de bus respectiva y actuará como intermediario entre usted y esta con la finalidad de obtener una resolución a su requerimiento. Recorrido.pe no tiene incidencia en las operaciones ni el tráfico de los operadores, solo comercializamos sus pasajes a través de nuestra plataforma online.","contact":"Lo contactaremos una vez que tengamos la respuesta de la empresa de buses, le pedimos disculpas de antemano, esto puede tardar algunos días."}}}


//////////////////
// WEBPACK FOOTER
// ./src/locals/es_PE.json
// module id = 9eaa
// module chunks = 1